import { ListItem } from '@rneui/themed'
import React, { useState } from 'react'
import { FlatList, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { SettingValue } from 'settings/types'
import { PressableOpacity } from 'shared/components/pressable_opacity'

interface Props {
  selectedId: string
  values: SettingValue[]
  onSelectValue(value: SettingValue): void
}

export function SingleSelectSettingView(props: Props) {
  const [selectedId, setSelectedId] = useState(props.selectedId)
  function onSelectValue(value: SettingValue) {
    setSelectedId(value.id)
    props.onSelectValue(value)
  }
  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <FlatList
          style={styles.list}
          data={props.values}
          keyExtractor={item => String(item.id)}
          renderItem={({ item }) => (
            <SingleSelectSettingValueRow
              value={item}
              selected={item.id === selectedId}
              onPress={() => onSelectValue(item)}
            />
          )}
        />
      </View>
    </SafeAreaView>
  )
}

interface ValueRowProps {
  value: SettingValue
  selected: boolean
  onPress(): void
}

export function SingleSelectSettingValueRow({
  value,
  selected,
  onPress,
}: ValueRowProps) {
  return (
    <PressableOpacity onPress={onPress}>
      <ListItem disabled={value.locked} containerStyle={styles.listItem}>
        <ListItem.Content>
          <ListItem.Title>{value.name}</ListItem.Title>
        </ListItem.Content>
        <ListItem.CheckBox
          onPress={onPress}
          iconRight
          checkedIcon="dot-circle-o"
          uncheckedIcon="circle-o"
          checked={selected}
        />
      </ListItem>
    </PressableOpacity>
  )
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  container: {
    marginHorizontal: 0,
    paddingHorizontal: 0,
  },

  list: {
    paddingVertical: 10,
  },

  listItem: {
    marginVertical: 8,
  },
})
